import graphqlClient from '~/graphql/graphqlClient';
import type {
  MutationEquipBagToHeroBagSlotArgs,
  ItemMoveResult,
} from 'dt-common/generated/graphql-types';

const mutation = `
mutation EquipBagToHeroBagSlot(
  $playerId: String!
  $from: ItemLocationInput!
  $to: ItemLocationInput!
) {
  equipBagToHeroBagSlot(
    playerId: $playerId
    from: $from
    to: $to
  ) {
    inventory
    heroRoster
  }
}
`;

export default async function mutationEquipBagToHeroBagSlot(
  args: MutationEquipBagToHeroBagSlotArgs
): Promise<ItemMoveResult> {
  return await graphqlClient.request<ItemMoveResult>('equipBagToHeroBagSlot', mutation, args);
}
